import { arrayMove } from '@dnd-kit/sortable';

import { PhotoShootImageData } from 'apis/mips/types';

import { CustomDragEndEvent, DroppableImageSlotData, SortableImageData } from '../../utils/typeGuards';

export const MENU_ITEM_MAX_IMAGES = 5;
export const getMenuItemImageIds = ({
  currentImages,
  newImageId,
  newImageSlotIndex,
}: {
  currentImages: DroppableImageSlotData['images'];
  newImageId: string;
  newImageSlotIndex: number;
}) => {
  const imageIds: string[] = [];

  for (let index = 0; index < MENU_ITEM_MAX_IMAGES; index++) {
    const isDroppingIntoThisSlot = index === newImageSlotIndex;
    const isThisSlotOccupied = Boolean(currentImages[index]);

    if (isDroppingIntoThisSlot) {
      imageIds.push(newImageId);
    } else if (isThisSlotOccupied) {
      imageIds.push(currentImages[index].id);
    }
  }

  return imageIds;
};

export const EMPTY_IMAGE_SLOT_ID_PREFIX = 'empty-image-slot';

export const getReorderedImageIds = (event: CustomDragEndEvent<SortableImageData, SortableImageData>): string[] => {
  const sortableData = event.active.data.current?.sortable;
  const droppableImageSlotData = event.over?.data.current;
  const currentImageIds = sortableData.items.filter(
    item => typeof item === 'string' && !item.startsWith(EMPTY_IMAGE_SLOT_ID_PREFIX),
  );
  const reorderedImageIds = arrayMove<string>(
    currentImageIds,
    sortableData.index,
    droppableImageSlotData?.sortable?.index,
  );

  return [droppableImageSlotData?.images[0].id, ...reorderedImageIds];
};

type ImageSlotRenderProps = {
  id: string;
  data: DroppableImageSlotData;
  isLoading: boolean;
  isReadOnly: boolean;
};

export const getSortableImageSlotsRenderProps = ({
  menuItemId,
  images,
  isLoading,
  isReadOnly,
}: {
  menuItemId: string;
  images: PhotoShootImageData[];
  isLoading: boolean;
  isReadOnly: boolean;
}): ImageSlotRenderProps[] =>
  Array.from({ length: MENU_ITEM_MAX_IMAGES - 1 }, (_, index) => ({
    id: images[index + 1]?.id || `${EMPTY_IMAGE_SLOT_ID_PREFIX}-${menuItemId}-${index + 1}`,
    data: { id: menuItemId, imageSlotIndex: index + 1, images, image: images[index + 1] },
    isLoading,
    isReadOnly,
  }));

export const getFileNameWithoutExtension = (fileName: string) =>
  fileName.includes('.') ? fileName.slice(0, fileName.lastIndexOf('.')) : fileName;
